import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormGroup, FormGroupName } from '@angular/forms';

@Component({
  selector: 'app-input-textarea',
  templateUrl: './input-textarea.component.html',
  styleUrls: ['./input-textarea.component.scss']
})
export class InputTextareaComponent {
  @Input() id: string;
  @Input() title: string;
  @Input() name: string;
  @Input() formGroup: FormGroup;
  @Input() controlName: string;
  @Input() readonly: boolean;
  @Input() length: number;
  @Input() placeholder: string = '';
  @Input() value: string = '';

  constructor() { }

  get formControl(): AbstractControl {
    return this.formGroup.controls[this.controlName];
  }

}
